import type { Step as RcStep } from '@sb/remote-control/types';

import { type ValidationRule, type RoutineView } from '../../types';
import type { WarningFinding } from '../../util/errors';
import {
  validateConditional,
  validateStoredConditionShape,
} from '../../util/validators';

import { CanonicalStepRuleBase } from './base';
import type { CanonicalValidateArgs } from './base';

class LoopRule extends CanonicalStepRuleBase {
  public constructor() {
    super('steps.Loop', 'Loop');
  }

  protected validate({ args, routine, warn }: CanonicalValidateArgs): void {
    type LArgs = Extract<RcStep.Arguments, { argumentKind: 'Loop' }>;
    const a = args as LArgs;
    warn(this.checkCondition(a, routine));
  }

  /**
   * Validate the loop condition against the routine.
   * Throws if invalid.
   *
   * @throws {ActionRequiredError}
   */
  private checkCondition(
    args: Extract<RcStep.Arguments, { argumentKind: 'Loop' }>,
    routine: RoutineView,
  ): WarningFinding | undefined {
    if (typeof args.condition !== 'string') return undefined;
    const conditions = JSON.parse(args.condition || '[]');

    validateStoredConditionShape(conditions);

    return validateConditional(conditions, routine);
  }
}

export const LoopValidation: ValidationRule = new LoopRule().toValidationRule();
